import React, { useState, useEffect } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardImg,
} from "reactstrap";

import classnames from "classnames";
import { Link } from "react-router-dom";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import _, { head, isObject, lowerCase } from "lodash";
import Select from "react-select";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
// MomentJS
import moment from "moment";
import { frxAppOptions, happeningTypeOptions, mallOptions } from "../../common/constants";
// import actions
import { connect } from "react-redux";
import {
  setAllCategories,
  setAllMerchants,
} from "../../store/cms-actions/postActions";
import { CircularProgress } from "@material-ui/core";
import ReactQuill from "react-quill";

const AddSplashBanners = (props) => {
  const ForceUpdate = useState()[1].bind(null, {});
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [token, setToken] = useState();
  const [FRXAPP, setFrxApp] = useState(false);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [selectedFRXSection, setselectedFRXSection] = useState(frxAppOptions[frxAppOptions.length-1]);
  const [selectedStatus, setselectedStatus] = useState(statusOptions[0]);
  const [neverEnding, setNeverEnding] = useState(false);
  const [force, setForce] = useState(false);
  const [success_msg, setsuccess_msg] = useState(false);
  const [success_msgText, setsuccess_msgText] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [errorMsgAlert, setErrorMsgAlert] = useState(false);
  const [activeTab, setactiveTab] = useState(1);
  const [pages, setPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState({});
  const [itemData, setItemData] = useState({});
  const [imageURL, setImageURL] = useState("");
  const [navigation, setNavigation] = useState({});
  const [edit,setEdit]=useState(false)
  const [externalUrl,setExternalUrl]=useState()
  const [externaLinkName,setExternalLinkName]=useState("")
  const [customCheck,setcustomCheck]=useState()
  const [customNavigation,setCustomNavigation]=useState(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"SplashBanner","Link":""}}))
  const [loader,setLoader]=useState(false)
  const [externalUrlErrorMessage,setExternalUrlErrorMessage]=useState('')
  const [selectedMall, setSelectedMall] = useState(null);
  const [selectedHappeningType, setSelectedHappeningType] = useState(null);
  const [perHour, setPerHour] = useState("1");
  const [noOfTimes, setNoOfTimes] = useState("1");



  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
      }
    }
  }
  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getPages(token, {});
    if (props?.location?.state?.edit) {
      setEdit(true)
      setFrxApp(true)
      setForce(props?.location?.state?.item?.banner_force)
      const data = props?.location?.state?.item;
      setPerHour(data?.per_hour ? String(data?.per_hour) : "1");
      setNoOfTimes(data?.no_of_times ? String(data?.no_of_times) : "5");
      let parsedNavigateTo = data ? JSON.parse(data?.navigate_to) : "";
      if(parsedNavigateTo?.url){
        setExternalUrl(parsedNavigateTo?.url)
        setExternalLinkName(parsedNavigateTo?.external_link_name)
      }
      if (parsedNavigateTo?.section === "ArticleDetail") {
        const [mallValue, happeningTypeValue, articleId] = parsedNavigateTo?.params?.data?.split('|') || [];
        const defaultMall = mallOptions?.find(option => option.label=== mallValue);
        if (defaultMall) {
          setSelectedMall(defaultMall);
        }
        const defaultHappeningType = happeningTypeOptions?.find(option => option.value === happeningTypeValue);
        if (defaultHappeningType) {
          setSelectedHappeningType(defaultHappeningType);
        }
        console.log("here is the coming article id--->", articleId);
      }
      setItemData(data);
      console.log(
        JSON.parse(data.navigate_to)
      );
      getPages(token, data);
      handleEditChanges(data);
    }
  }, [success_msg]);

  useEffect(() => {
    const data = props?.location?.state?.item;
      handleEditChanges(data);
  }, []);

  const handleEditChanges = (data) => {
    let navigation1 = {};
    if (data?.navigate_to?.includes("{")) {
      navigation1 = JSON.parse(data?.navigate_to);
      setNavigation(navigation1);
    }
   setNavigation(navigation1)
    if (data?.unpublished_at == "null") {
      setNeverEnding(true);
    }
    setImageURL(data?.image_url);
    statusOptions?.map((item) => {
      if (item?.value == data?.item_status) {
        setselectedStatus(item);
      }
    });

    if(navigation1?.custom){
      setcustomCheck(true)
      setCustomNavigation(props?.location?.state?.item?.navigate_to)
    }
    else{
      setcustomCheck(false)
      setCustomNavigation(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"SplashBanner","Link":""}})) 
      if (data?.navigate_to?.includes("{")) {
      if(navigation1?.params?.show_add_selection_modal){
        setselectedFRXSection({ label: "Add Gift Card", value: "add_gift_card"})
        }else if(navigation1?.params?.show_buy_selection_modal){
           setselectedFRXSection({ label: "Buy Gift Card", value: "buy_gift_card"})
        }else{
          frxAppOptions?.map((item) => {
          if (item?.value == navigation1?.section) {
            setselectedFRXSection(item);
            return;
          }
        });}
      
    } else {
      frxAppOptions?.map((item) => {
        if (item.value == data?.navigate_to) {
          setselectedFRXSection(item);
        } else {
          if (data?.navigate_to.includes("")) {
            setselectedFRXSection({ label: "No Navigation", value: "" });
            return;
          }
        }
      });
    }
  };
}
  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (path == "jpg"  || path == "JPG" || path== "gif" || path== "GIF") {
      setselectedFiles(files);
      setImageURL("")
    } else {
      SetErrorMessage("Please select a .jpg,.gif file");
      setErrorMsgAlert(true);
    }
  }

  const getPages = (token, data = {}) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=banners&env=production`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        let newPageArr = [];
        if (result?.pages?.length > 0) {
          let enabled = result?.pages.filter((item) => item.status == "enable");
          enabled?.length > 0 &&
            enabled?.map((item) => {
              newPageArr.push({ value: item.page_name, label: item.page_name });
            });
            console.log("here is the new page array--->",newPageArr)
            var replaceData= newPageArr.map((item)=>{            
              if(item.value === "E-Wallet"){
                item.value = "E-Wallet";
                item.label="e-wallet";
                return item
              }else if(item.value==="HomeScreen"){
                item.value="HomeScreen"
                item.label="Home"
              }
              return item            
            })
            
          var newPageData= replaceData.filter(item => !["Announcement","campaign_dgc_mini_ff","Campaign_CarparkMainPage", "Campaign_services", "Services","Campaign_services","Campaign_rewards","Homescreen","PaymentBanner","Campaign_ewallet","Campaign","campaign_dynamic_1001","campaign_dynamic_1002","End_of_trip","events","facilities","mini_home_consented","mini_rewards","mini_top_up","signin_mini","mini_home_not_consented","mini_load_dgc","estore_web_mini","Campaign_blog",'Campaign_deals','Campaign_promotions','Payments','Campaign_event','Campaign_buyforfriend','Campaign_cardart','Campaign_orderreview',"Campaign_dgcMain","Campaign_dgcListing","Campaign_orderreviewMyself","Campaign_buyformyself","campaign_dgc_mini","MM_mini_Banner"].includes(item.value)) 
          let sortedArray= newPageData.sort(function(a, b) {
            return a.label.localeCompare(b.label);
         });        
          sortedArray?.length > 0 &&
            isObject(data) &&
            sortedArray?.map((item) => {
              if (item.value === data.page) {
                setSelectedPage(item);
                ForceUpdate();
              }
            });
          setPages(sortedArray);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={()=>{
          props?.history.push(`/marketing-banners/splash-screens`);
          }}
        onConfirm={() => {
          props?.history.push(`/marketing-banners/splash-screens`);
          setsuccess_msg(false);
          setLoader(false)
        }}
        onCancel={() => {
          setsuccess_msg(false);
        }}
      >
        {props?.location?.state?.edit ? "Splash Banner Updated Successfuly" : "Splash Banner Added Successfuly"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const handleDateChange = (e, item) => {
    if (item == 1) {
      setItemData((state) => {
        const st = { ...state, published_at: e.target.value };
        return st;
      });
    } else if (item == 2) {
      setItemData((state) => {
        const st = { ...state, unpublished_at: e.target.value };
        return st;
      });
    }
  };
  function handleUpdate() {
    const link = document.getElementById("campaign_link_input")?.value ? document.getElementById("campaign_link_input")?.value:"";
    const article_id = document.getElementById("article_id")?.value;
    const titleFRX = document
      .getElementById("title_input_frx")
      ?.value
    let publishAt = moment(
      document.getElementById("publishAt_input").value
    )?.format("YYYY/MM/DD HH:mm");
    let unpublishAt = moment(
      document.getElementById("unpublishAt_input").value
    )?.format("YYYY/MM/DD HH:mm");
    const status = selectedStatus ? selectedStatus.value : "";
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    currentDate = currentDate.toString();
    
    if (!imageURL) {
      if (selectedFiles.length < 1) {
        SetErrorMessage("Please select image");
        setErrorMsgAlert(true);
        toggleTab(1)
        return;
      }
    }
    else if (!neverEnding) {
      if(unpublishAt == "Invalid date" || unpublishAt == ""){
      SetErrorMessage("Please select unpublish date")
      setErrorMsgAlert(true)
      toggleTab(1);
      return }
      else if(unpublishAt < publishAt){
        SetErrorMessage("Unpublish date should be after the publish date")
        setErrorMsgAlert(true)
        toggleTab(1)
        return
      }
    } else if(customCheck){
      if(!customNavigation){
        SetErrorMessage("Please Enter Navigation")
        setErrorMsgAlert(true)
        return
      }
  }else if(!customCheck){
    if(!selectedFRXSection){
      SetErrorMessage("Please Select Navigation")
      setErrorMsgAlert(true)
      return
    }
  }

  if(selectedFRXSection.value == "NA"){
    if(!externalUrl){
      SetErrorMessage("Please Enter URL")
      setErrorMsgAlert(true)
      return
    }else if(externalUrlErrorMessage){
      SetErrorMessage("Please enter valid URL")
      setErrorMsgAlert(true)
      return
    }else if(!checkTextInsideHtml(externaLinkName)){
      SetErrorMessage("Please Enter Exit Message Description")
      setErrorMsgAlert(true)
      return
    }
  }
  
  if(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck){
    if(!link){
      SetErrorMessage("Please Enter campaign tracking name")
      setErrorMsgAlert(true)
      return
    }
  }
  
    setLoader(true)
    let _deeplinkObjFRX = {
      section: "",
      params: {
        
      },
    };

  if(!customCheck){
    if (FRXAPP) {
      if (selectedFRXSection) {
        _deeplinkObjFRX.section = selectedFRXSection.value;
        _deeplinkObjFRX.params.CampaignMedium = "SplashBanner";
        _deeplinkObjFRX.params.Link = link;

        if (selectedFRXSection.value == "ewallet") {
          // _deeplinkObjFRX.params = selectedFRXSection.params;
          _deeplinkObjFRX.params.CampaignMedium = "SplashBanner";
          _deeplinkObjFRX.params.Link = link;
        }else if (selectedFRXSection.value == "NA") {
          _deeplinkObjFRX={}
          _deeplinkObjFRX.section = "NA";
          _deeplinkObjFRX.url=externalUrl;
          _deeplinkObjFRX.external_link_name=externaLinkName;
        }else if (selectedFRXSection.value == "UobUni") {
          _deeplinkObjFRX.section = "UobUni";
        }else if (selectedFRXSection.value == "ShowQR") {
          _deeplinkObjFRX.section = "ShowQR";
        }else if (selectedFRXSection.value == "digital_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params._params ="digital_gift_card_listing";
        }else if(selectedFRXSection?.value == "FRxMemberSpending"){
          _deeplinkObjFRX.login_required = true
        }else if (selectedFRXSection.value == "add_gift_card") {
          _deeplinkObjFRX.section ="digital_gift_card";
          _deeplinkObjFRX.params.show_add_selection_modal = true;
        }else if (selectedFRXSection.value == "buy_gift_card") {
          _deeplinkObjFRX.section ="digital_gift_card";
          _deeplinkObjFRX.params.show_buy_selection_modal = true;
        } else if (selectedFRXSection.value == "ArticleDetail") {
          _deeplinkObjFRX.params.data = `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`;
          _deeplinkObjFRX.params.title = titleFRX;
          _deeplinkObjFRX.params.article = {
            category: titleFRX,
            id: `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`,
          };
        } else if (selectedFRXSection.value == "RewardsTab") {
          _deeplinkObjFRX.params.Link = link;
        } 
   else if (selectedFRXSection.value == "No Navigation") {
          _deeplinkObjFRX = " ";
        }else if (selectedFRXSection.value == "BuyForMySelf") {
          _deeplinkObjFRX.params.buy_for="me"
        }
      }
    }else {
      _deeplinkObjFRX.section = navigation.section;
      _deeplinkObjFRX.params = navigation.params;
    }
}
    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "banners/update");
    formdata.append("item_id", itemData?.item_id);
    formdata.append("page", selectedPage?.value && selectedPage?.value);
    formdata.append("per_hour", perHour || "1");
    formdata.append("no_of_times", noOfTimes || "1");
    formdata.append("banner_type", "splash_screen");
    if (selectedFiles?.length > 0) {
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }
    formdata.append("item_status", status);
    formdata.append("item_type", '"banner"');
    if (force) {
      formdata.append("banner_force", 1);
    } else {
      formdata.append("banner_force", 0);
    }
    formdata.append("item_version", 18);
    formdata.append("navigate_to",customCheck ? customNavigation : JSON.stringify(_deeplinkObjFRX));
    formdata.append("published_at", publishAt);
    formdata.append("unpublished_at", neverEnding ? null : unpublishAt);
    formdata.append("api", true);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          setsuccess_msgText("Splash Banner updated successfully.");
          setsuccess_msg(true);
          setLoader(false)
        } else {
          SetErrorMessage("Unable to update Splash Banner");
          setErrorMsgAlert(true);
          setLoader(false)
        }
        response.json();
      })
      .catch((error) =>{ console.log("error", error)
      SetErrorMessage("Unable to update Splash Banner");
      setErrorMsgAlert(true);
      setLoader(false)
    });
  }

  function handleSubmit() {
    const link = document.getElementById("campaign_link_input")?.value ? document.getElementById("campaign_link_input")?.value:"";
    const article_id = document.getElementById("article_id")?.value;
    const titleFRX = document
      .getElementById("title_input_frx")
      ?.value
    let publishAt = moment(
      document.getElementById("publishAt_input").value
    )?.format("YYYY/MM/DD HH:mm");
    let unpublishAt = moment(
      document.getElementById("unpublishAt_input").value
    )?.format("YYYY/MM/DD HH:mm");
    const status = selectedStatus ? selectedStatus.value : "";
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    currentDate = currentDate.toString();
    if(!selectedPage?.value){
      SetErrorMessage("Please select Page");
      setErrorMsgAlert(true);
      toggleTab(1);
      return
    }
    else  if (selectedFiles.length < 1) {
      SetErrorMessage("Please select image");
      setErrorMsgAlert(true);
      toggleTab(1);
      return;
    } else if (publishAt == "Invalid date") {
      SetErrorMessage("Please select publish date")
      setErrorMsgAlert(true)
      toggleTab(1);
      return
    } else if (!neverEnding) {
      if(unpublishAt == "Invalid date"){
      SetErrorMessage("Please select unpublish date")
      setErrorMsgAlert(true)
      toggleTab(1);
      return
         }
      else if(unpublishAt < publishAt){
      SetErrorMessage("Unpublish date should be after the publish date")
      setErrorMsgAlert(true)
      toggleTab(1)
      return
      }
    }  else if(customCheck){
      if(!customNavigation){
        SetErrorMessage("Please Enter Navigation")
        setErrorMsgAlert(true)
        return
      }
  }

  if(selectedFRXSection.value == "NA"){
    if(!externalUrl){
      SetErrorMessage("Please Enter URL")
      setErrorMsgAlert(true)
      return
    }else if(!checkTextInsideHtml(externaLinkName)){
      SetErrorMessage("Please Enter Exit Message Description")
      setErrorMsgAlert(true)
      return
    }
  }

  if(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck){
    if(!link){
      SetErrorMessage("Please Enter campaign tracking name")
      setErrorMsgAlert(true)
      return
    }
  }

    setLoader(true)

    let _deeplinkObjFRX = {
      section: "",
      params: {
        
      },
    };
if(!customCheck){
  if (FRXAPP) {
    if (selectedFRXSection) {
      _deeplinkObjFRX.section = selectedFRXSection.value;
      _deeplinkObjFRX.params.CampaignMedium = "SplashBanner";
      _deeplinkObjFRX.params.Link = link;

      if (selectedFRXSection.value == "ewallet") {
        _deeplinkObjFRX.params.CampaignMedium = "SplashBanner";
        _deeplinkObjFRX.params.Link = link;  
      }else if (selectedFRXSection.value == "NA") {
        _deeplinkObjFRX={}
        _deeplinkObjFRX.section = "NA";
        _deeplinkObjFRX.url=externalUrl;
        _deeplinkObjFRX.external_link_name=externaLinkName;
      }else if (selectedFRXSection.value == "UobUni") {
        _deeplinkObjFRX.section = "UobUni";
      }else if (selectedFRXSection.value == "ShowQR") {
        _deeplinkObjFRX.section = "ShowQR";
      }else if (selectedFRXSection.value == "digital_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params._params ="digital_gift_card_listing";
      }else if(selectedFRXSection?.value == "FRxMemberSpending"){
        _deeplinkObjFRX.login_required = true
      }
      else if (selectedFRXSection.value == "add_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params.show_add_selection_modal = true;
      }else if (selectedFRXSection.value == "buy_gift_card") {
        _deeplinkObjFRX.section = "digital_gift_card";
        _deeplinkObjFRX.params.show_buy_selection_modal = true;
      } else if (selectedFRXSection.value == "ArticleDetail") {
        _deeplinkObjFRX.params.data = `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`;
        _deeplinkObjFRX.params.title = titleFRX;
        _deeplinkObjFRX.params.article = {
          category: titleFRX,
          id: `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`,
        };
      } else if (selectedFRXSection.value == "RewardsTab") {
        _deeplinkObjFRX.params.Link = link;
      } else if (selectedFRXSection.value == "No Navigation") {
        _deeplinkObjFRX = " ";
      }else if (selectedFRXSection.value == "BuyForMySelf") {
        _deeplinkObjFRX.params.buy_for="me"
     }
    }
  }
}


    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "banners/add");
    formdata.append("page", selectedPage?.value && selectedPage?.value);
    formdata.append("per_hour", perHour || "1");
    formdata.append("no_of_times", noOfTimes || "1");
    formdata.append("banner_type", "splash_screen");
    formdata.append("created_datetime", currentDate);
    formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    formdata.append("item_status", status);
    formdata.append("item_type", '"banner"');
    if (force) {
      formdata.append("banner_force", 1);
    }else{
      formdata.append("banner_force", 0);
    }
    formdata.append("item_version", 18);
    formdata.append("navigate_to",customCheck ? customNavigation : JSON.stringify(_deeplinkObjFRX));
    formdata.append("published_at", publishAt);
    formdata.append("unpublished_at", neverEnding ? null : unpublishAt);
    formdata.append("api", true);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          setsuccess_msg(true);
          setLoader(false)
        } else {
          SetErrorMessage("Unable to Add Splash Banner");
          setErrorMsgAlert(true);
          setLoader(false)
        }
        response.json();
      })
      .catch((error) => {console.log("error", error)
      SetErrorMessage("Unable to Add Splash Banner");
      setErrorMsgAlert(true);
      setLoader(false)    
    });
  }
  const checkCharacterCount = (e, count) => {
    if (e.target.innerText.length > count && e.key !== 'Backspace') {
      e.preventDefault()
    }
  }

  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };
  const validateFileSize = (file) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;

        if (width !== 400 || height !== 800) {
          SetErrorMessage("Height and Width must be 400x800px");
          setErrorMsgAlert(true);
        }else{
          handleAcceptedFiles(file);
        }
      };
    };
  };
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const handleExternalUrl = (value) =>{
    setExternalUrl(value)
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if(value){
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage("Please enter valid URL (Including https://)");
      } else {
        setExternalUrlErrorMessage("");
      }
    }else{
      setExternalUrlErrorMessage("");
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="Marketing Banners"
            breadcrumbItem="Add Splash Banner"
          />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1);
                            }}
                          >
                            <span className="number">1.</span> Create Splash
                            Banner
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2);
                            }}
                          >
                            <span className="number">2.</span> {"Navigation"}
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <div className="body">
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId={1}>
                            <Form>
                              <Row></Row>
                            </Form>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={10} md={10} sm={10}>
                                        <div className="mt-5 mt-lg-4">
                                          <Form
                                            className=""
                                            method="post"
                                            id="tooltipForm"
                                          >
                                            <div>
                                              <Row>
                                                <Col lg={4} md={6} sm={6}>
                                                  <div className="mb-3">
                                                    <Label>Page</Label>
                                                    <Select
                                                      isSearchable={true}
                                                      value={selectedPage}
                                                      onChange={(e) => {
                                                        setSelectedPage(e);
                                                      }}
                                                      options={pages}
                                                      placeholder={
                                                        selectedPage
                                                          ? selectedPage.label
                                                          : "Choose..."
                                                      }
                                                      defaultValue={
                                                        pages[0]?.value
                                                      }
                                                      required
                                                    />
                                                  </div>
                                                </Col>
                                                <Col lg={1}></Col>
                                                <Col style={{ paddingTop: 35 }}>
                                                  <div className="form-check form-switch">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input checkbox"
                                                      id="checkbox_1"
                                                      checked={force}
                                                      onChange={() => {
                                                        setForce(!force);
                                                      }}
                                                    />

                                                    <label
                                                      className="form-check-label"
                                                      htmlFor="checkbox_1"
                                                    >
                                                      Force
                                                    </label>
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col lg={4} md={6} sm={6}>
                                                  <div className="mb-3">
                                                    <Label>Per Hour</Label>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={perHour}
                                                      onChange={(e) => {
                                                        setPerHour(e.target.value);
                                                      }}
                                                      // placeholder="1"
                                                    />
                                                  </div>
                                                </Col>
                                                <Col lg={1}></Col>
                                                <Col lg={4} md={6} sm={6}>
                                                  <div className="mb-3">
                                                    <Label>No Of Times</Label>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={noOfTimes}
                                                      onChange={(e) => {
                                                        setNoOfTimes(e.target.value);
                                                      }}
                                                      // placeholder="5"
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>
                                          </Form>
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Form>
                                      {imageURL && (
                                        <Row>
                                          <Col lg={2}>
                                            <CardImg
                                              className="img-fluid"
                                              src={imageURL}
                                              style={{
                                                marginBottom: 15,
                                                width: "150px",
                                                height:"300px" 
                                              }}
                                              alt=""
                                            />
                                          </Col>
                                          <Col lg={3}>
                                            <div
                                              className="px-3 text-danger"
                                              style={{cursor:"pointer"}}
                                              onClick={() => {
                                                setImageURL("");
                                              }}
                                            >
                                             <p><FaRegTrashAlt />Move To Trash</p>
                                            </div>
                                          </Col>
                                        </Row>
                                      )}
                                      <Dropzone
                                        onDrop={(acceptedFiles) => {
                                          validateFileSize(acceptedFiles)
                                        }}
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <div className="dropzone">
                                            <div
                                              className="dz-message needsclick"
                                              {...getRootProps()}
                                            >
                                              <input {...getInputProps()} />
                                              <div className="mb-3">
                                              <FaCloudUploadAlt className="display-4 text-muted"/>
                                              </div>
                                              <h4>
                                                Drop files here or click to
                                                upload.
                                              </h4>
                                              <p style={{ fontSize: 12, color: "red" }}>Image should be 400x800px in jpg,gif<br/>
                                              </p>
                                            </div>
                                          </div>
                                        )}
                                      </Dropzone>
                                      <div
                                        className="dropzone-previews mt-3"
                                        id="file-previews"
                                      >
                                        {selectedFiles.map((f, i) => {
                                          return (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i + "-file"}
                                            >
                                              <div className="p-2">
                                                <Row className="align-items-center">
                                                  <Col className="col-auto">
                                                    <img
                                                      data-dz-thumbnail=""
                                                      height="80"
                                                      className="avatar-sm rounded bg-light"
                                                      alt={f.name}
                                                      src={f.preview}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="text-muted font-weight-bold"
                                                    >
                                                      {f.name}
                                                    </Link>
                                                    <p className="mb-0">
                                                      <strong>
                                                        {f.formattedSize}
                                                      </strong>
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </Card>
                                          );
                                        })}
                                      </div>
                                    </Form>
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Publish At</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              value={
                                                itemData.published_at
                                                  ? moment(
                                                      itemData?.published_at
                                                    ).format("YYYY-MM-DDTHH:mm")
                                                  : ""
                                              }
                                              onChange={(e) => {
                                                handleDateChange(e, 1);
                                              }}
                                              placeholder={
                                                itemData?.published_at
                                                  ? moment(
                                                      itemData?.published_at
                                                    ).format("YYYY-MM-DDTHH:mm")
                                                  : moment(new Date()).format(
                                                      "YYYY-MM-DDTHH:mm"
                                                    )
                                              }
                                              type="datetime-local"
                                              id="publishAt_input"
                                              min={moment(new Date()).format(
                                                "YYYY-MM-DD"
                                              )}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col lg={1}></Col>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Unpublish At</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="datetime-local"
                                              id="unpublishAt_input"
                                              value={
                                                itemData?.unpublished_at
                                                  ? moment(
                                                      itemData?.unpublished_at
                                                    ).format("YYYY-MM-DDTHH:mm")
                                                  : ""
                                              }
                                              onChange={(e) => {
                                                handleDateChange(e, 2);
                                              }}
                                              min={moment(new Date()).format(
                                                "YYYY-MM-DD"
                                              )}
                                              placeholder={
                                                itemData?.unpublished_at
                                                  ? moment(
                                                      itemData?.unpublished_at
                                                    ).format("YYYY-MM-DDTHH:mm")
                                                  : moment(new Date())
                                                      .add(2, "days")
                                                      .format(
                                                        "YYYY-MM-DDTHH:mm"
                                                      )
                                              }
                                              disabled={neverEnding}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col style={{ paddingTop: 35 }}>
                                        <div className="form-check form-switch">
                                          <input
                                            type="checkbox"
                                            className="form-check-input checkbox"
                                            id="checkbox_1"
                                            checked={neverEnding}
                                            onChange={() => {
                                              setNeverEnding(!neverEnding);
                                            }}
                                          />

                                          <label
                                            className="form-check-label"
                                            htmlFor="checkbox_1"
                                          >
                                            Never-ending
                                          </label>
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Status</Label>
                                          <Select
                                            isSearchable={true}
                                            // value={selectedStatus}
                                            onChange={(e) => {
                                              setselectedStatus(e);
                                            }}
                                            options={statusOptions}
                                            placeholder={
                                              selectedStatus
                                                ? selectedStatus.label
                                                : "Choose..."
                                            }
                                            defaultValue={
                                              statusOptions[0].label
                                            }
                                            required
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Form>
                                <Row>
                                  <Col lg={4} md={10} sm={10}>
                                    <div className="mb-3">
                                      <Label>Navigate To</Label>
                                      {customCheck ? 
                                        <textarea
                                        rows={4}
                                        col={20}
                                        type="text"
                                        className="form-control"
                                        id="item_group_input"
                                        onChange={(e) => {
                                          setCustomNavigation(e.target.value);
                                        }}
                                        defaultValue={customNavigation}
                                      />
                                      :<Select
                                        isSearchable={true}
                                        value={selectedFRXSection}
                                        onChange={(e) => {
                                          setselectedFRXSection(e);
                                          setFrxApp(true);
                                        }}
                                        placeholder={
                                          selectedFRXSection?.label
                                            ? selectedFRXSection?.label
                                            : "Choose section..."
                                        }
                                        defaultValue={frxAppOptions[0]}
                                        options={frxAppOptions}
                                        maxMenuHeight={120}
                                        menuPlacement="auto"
                                        required
                                      />}
                                    </div>
                                  </Col>
                                  <Col md={1}></Col>
                                  <Col md={2} style={{paddingTop:"38px"}}>
                                  <div className="form-check form-switch">
                                    <input
                                      type="checkbox"
                                      className="form-check-input checkbox"
                                      id="checkbox_custom_nav"
                                      value={customCheck}
                                      defaultChecked={customCheck}
                                      onClick={() => { 
                                      setcustomCheck(!customCheck)
                                      }}
                                    />

                                    <label className="form-check-label" htmlFor="checkbox_pocuno">
                                      Custom Navigation
                                    </label>
                                  </div>
                                  </Col>
                                </Row>
                                <Row>
                                { (selectedFRXSection?.label == "External Link" && !customCheck) &&
                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      <Label>URL*</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={externalUrl}
                                        id="external_url_input"
                                        onChange={(e) => {setFrxApp(true)
                                        handleExternalUrl(e.target.value)}}
                                      />
                                      {externalUrlErrorMessage && (
                                      <p style={{ color: "red", fontSize: 12 }}>
                                        {externalUrlErrorMessage}
                                      </p>
                                    )}
                                    </div>
                                  </Col>}
                                </Row>
                                <Row>
                                  {(selectedFRXSection?.label == "External Link" && !customCheck) &&
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>{"Exit Message Description*"}</Label>
                                        <ReactQuill
                                          modules={{
                                            toolbar: [
                                              ["bold", "italic", "underline"],
                                              [{ list: "ordered" }, { list: "bullet" }],
                                              ["link", { color: [] }],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          value={externaLinkName}
                                          onChange={(e, delta, source, c) => {
                                            if (c.getText().length <= 2000) {
                                              setExternalLinkName(e);
                                            } else if (c.getText().length > 2000) {
                                              const remainingCharacters = 2000 - c.getText().length;
                                              let truncatedText = c.getText().slice(0, remainingCharacters);
                                              setExternalLinkName(truncatedText)
                                            }
                                          }}
                                          onKeyDown={(e) => checkCharacterCount(e, 2000)}

                                          style={{ minHeight: "30px" }}
                                        />
                                      </div>
                                    </Col>}
                                  <Col md={1}></Col>
                                </Row>
                              {(selectedFRXSection?.value == "ArticleDetail" && !customCheck) && (
                                <>
                                  <Row>
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>Mall</Label>
                                        <Select
                                          isSearchable={true}
                                          onChange={(e) => {
                                            setSelectedMall(e);
                                            setSelectedHappeningType(null);
                                          }}
                                          options={mallOptions}
                                          placeholder="Select Mall..."
                                          value={selectedMall}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  
                                  {selectedMall && (
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Type</Label>
                                          <Select
                                            isSearchable={true}
                                            onChange={(e) => {
                                              setSelectedHappeningType(e);
                                            }}
                                            options={happeningTypeOptions}
                                            placeholder="Select Happening Type..."
                                            value={selectedHappeningType}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  
                                  {selectedHappeningType && (
                                    <>
                                      <Row>
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                         <Label>Blog ID</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={
                                            navigation?.params?.data?.split('|')[2] || ''
                                          }
                                            id="article_id"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                      <Row >
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                        <Label>Header Title</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={
                                              isObject(navigation) &&
                                              navigation?.params?.title
                                            }
                                            id="title_input_frx"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </>
                              )}
                                <Row>
                                  <Col lg={4} md={6} sm={6}>
                                    {(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck) &&<div className="mb-3">
                                      <Label>Campaign Tracking Name</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={
                                          isObject(navigation) &&
                                          navigation?.params?.Link
                                        }
                                        id="campaign_link_input"
                                        onChange={(e) => setFrxApp(true)}
                                      />
                                    </div>}
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li className={"next"}>
                          <Link
                            to={`/marketing-banners/${'splash-screens'}`}
                            className="bg-danger"
                            // onClick={() => {
                            //   toggleTab(activeTab - 1)
                            // }}
                            style={{ paddingTop: 8, paddingBottom: 10 }}
                          >
                            <i className="uil uil-times me-1"></i>Cancel
                          </Link>
                        </li>
                        <li
                          className={
                            activeTab === 1 ? "previous hidden" : "previous"
                          }
                        >
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab(activeTab - 1);
                            }}
                          >
                            Previous
                          </Link>
                        </li>
                        <li
                          className={activeTab === 4 ? "next disabled" : "next"}
                        >
                          <button
                          disabled={loader}
                          style={{color:"#ffffff", width:"80px"}}
                            //btn btn-primary
                            className={
                              activeTab > 1
                                ? "btn bg-success"
                                : "btn btn-primary"
                            }
                            onClick={() => {
                              if (activeTab === 2) {
                                if (edit) {
                                  handleUpdate();
                                } else {
                                  handleSubmit();
                                }
                                return;
                              } else {
                                toggleTab(activeTab + 1);
                              }
                            }}
                          >
                            {activeTab === 2 ? loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save" : "Next"}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {success_msg ? renderSuccessAlert() : null}
          {errorMsgAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { allCategories, allMerchants } = state.rootReducers1;
  return { allCategories, allMerchants };
};

const actions = {
  setAllCategories,
  setAllMerchants,
};

export default connect(mapStateToProps, actions)(AddSplashBanners);
